const addformdatadialog = [{
		inputdata: "",
		title: "出库单号",
		fontSize: "14px",
		color: "#333333",
		placeholder: "请输入",
		types: "text",
		inputtype: "input",
		width: "180px",
		lablewith: "80px",
		btx: false,
	},
	{
		inputdata: "",
		title: "出库日期",
		fontSize: "14px",
		color: "#333333",
		placeholder: "请输入",
		types: "",
		inputtype: "datess",
		width: "180px",
		lablewith: "120px",
		btx: true,
	},
	{
		inputdata: "",
		title: "产品线",
		fontSize: "14px",
		color: "#333333",
		placeholder: "全部",
		types: "",
		inputtype: "select",
		width: "190px",
		btx: true,
		lablewith: "120px",
		options: [],
		event: "invClass",
	},
	{
		title: "经销商",
		inputtype: "selectautocompletes",
		modelvalue: '',
		inputflag: true,
		fontSize: '14px',
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "text",
		placeholder: "请输入",
		width: '190px',
		height: '32px',
		disabled: false,
		marginLeft: '25px',
		marginTop: '5px',
		displayVal: "inline-block",
		fontWeightVal: 500,
		options: [],
		loading: false,
		remoteMethod: 'AuthorizedDealer'
	},
	{
		inputdata: "",
		title: "备注",
		fontSize: "14px",
		color: "#333333",
		placeholder: "请输入",
		types: "text",
		inputtype: "input",
		width: "180px",
		lablewith: "95px",
	},
	{
		title: "寄售方",
		inputtype: "selectautocompletes",
		modelvalue: '',
		inputflag: true,
		fontSize: '14px',
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "text",
		placeholder: "请输入",
		width: '190px',
		height: '32px',
		disabled: false,
		marginLeft: '25px',
		marginTop: '5px',
		displayVal: "inline-block",
		fontWeightVal: 500,
		options: [],
		loading: false,
		remoteMethod: 'AuthorizedHospit'
	}
];
export default addformdatadialog;